import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadIx2031ListStatus: 'idle',
    loadIx2031ListError: undefined as any,
    loadIx2031ListLastArgs: undefined as any,
    loadIx2031Status: 'idle',
    loadIx2031Error: undefined as any,
    saveIx2031Status: 'idle',
    saveIx2031Error: undefined as any,
    deleteIx2031Status: 'idle',
    deleteIx2031Error: undefined as any,

    ix2031List: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIx2031List = createAsyncThunk('ix2031Slice/loadIx2031List', async ({ gridFilters, utils, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ix2031Slice.loadIx2031ListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, utils }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/xsp_ebtransactions/?CURRENTUSERID=${utils.currUserId()}&FILTERBUKREIS=${gridFilters.values.FILTERBUKREISFILTER||-2}&FILTERUSER=${gridFilters.values.FILTERUSERFILTER}&FILTERKASZSTATUSINCLUDE=${gridFilters.values.FILTERKASZSTATUSINCLUDEFILTER}&FILTERKASZSTATUSEXCLUDE=${gridFilters.values.FILTERKASZSTATUSEXCLUDEFILTER}&FILTERKALINESTATUSINCLUDE=${gridFilters.values.FILTERKALINESTATUSINCLUDEFILTER}&FILTERDATEFROM=${gridFilters.values.FILTERDATEFROMFILTER}&FLTERDATETO=${gridFilters.values.FLTERDATETOFILTER}&MAXEBKALNTOFILTER=${gridFilters.values.MAXEBKALNTOFILTERFILTER}&EbKaLnId=0&EbKaSzId=0&EbKtoId=0`, undefined)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, utils }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2031ListStatus } = getState().ix2031Slice
        return loadIx2031ListStatus !== 'pending'
    }
})

export const loadIx2031 = createAsyncThunk('ix2031Slice/loadIx2031', async ({ ix2031, utils }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/xsp_ebtransactions/?CURRENTUSERID=${utils.currUserId()}&FILTERBUKREIS=-2&FILTERUSER=-2&FILTERKASZSTATUSINCLUDE=&FILTERKASZSTATUSEXCLUDE=&FILTERKALINESTATUSINCLUDE=&FILTERDATEFROM=&FLTERDATETO=&MAXEBKALNTOFILTER=0&EbKaLnId=${ix2031.HDR_ID}&EbKaSzId=0&EbKtoId=0`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2031Status } = getState().ix2031Slice
        return loadIx2031Status !== 'pending'
    }
})

export const saveIx2031 = createAsyncThunk('ix2031Slice/saveIx2031', async ({ ix2031 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/startProcessEbie2031/`,
        prepareData(ix2031),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveIx2031Status } = getState().ix2031Slice
        return saveIx2031Status !== 'pending'
    }
})

export const deleteIx2031 = createAsyncThunk('ix2031Slice/deleteIx2031', async ({ ix2031 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ebkaln/?{ix2031.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: ix2031.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteIx2031Status } = getState().ix2031Slice
        return deleteIx2031Status !== 'pending'
    }
})

const Ix2031Slice = createSlice({
    name: 'ix2031Slice',
    initialState,
    reducers: {
        resetloadIx2031ListError: (state) => {
            state.loadIx2031ListError = undefined
        },
        resetloadIx2031: (state) => {
            state.formItem = undefined
            state.loadIx2031Error = undefined
        },
        resetloadIx2031Error: (state) => {
            state.loadIx2031Error = undefined
        },
        resetsaveIx2031: (state) => {
            state.formItem = undefined
            state.saveIx2031Error = undefined
        },
        resetsaveIx2031Error: (state) => {
            state.saveIx2031Error = undefined
        },
        resetdeleteIx2031Error: (state) => {
            state.deleteIx2031Error = undefined
        },
        removeFromIx2031ListById: (state, action) => {
            state.ix2031List = state.ix2031List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromIx2031ListByIds: (state, action) => {
            state.ix2031List = state.ix2031List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ix2031List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIx2031ListStatus = 'preloaded'
            state.loadIx2031ListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ix2031List = []
            state.loadIx2031ListStatus = 'idle'
            state.loadIx2031ListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIx2031List.pending, (state) => {
            state.loadIx2031ListStatus = 'pending'
            state.loadIx2031ListError = undefined
        })
        builder.addCase(loadIx2031List.fulfilled, (state, action) => {
            state.loadIx2031ListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIx2031ListLastArgs = action.payload.args

            {
                state.ix2031List = action.payload.data

            }
        })
        builder.addCase(loadIx2031List.rejected, (state, action) => {
            state.loadIx2031ListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2031ListError = action.error.message
            } else {
                state.loadIx2031ListError = action.payload
            }
        })

        builder.addCase(loadIx2031.pending, (state) => {
            state.loadIx2031Status = 'pending'
            state.loadIx2031Error = undefined
        })
        builder.addCase(loadIx2031.fulfilled, (state, action) => {
            state.loadIx2031Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix2031List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix2031List.push(newItem) }
                else { state.ix2031List[i] = { ...state.ix2031List[i], ...newItem } }
            }
        })
        builder.addCase(loadIx2031.rejected, (state, action) => {
            state.loadIx2031Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2031Error = action.error.message
            } else {
                state.loadIx2031Error = action.payload
            }
        })

        builder.addCase(saveIx2031.pending, (state) => {
            state.saveIx2031Status = 'pending'
            state.saveIx2031Error = undefined
        })
        builder.addCase(saveIx2031.fulfilled, (state, action) => {
            state.saveIx2031Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix2031List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix2031List.push(newItem) }
                else { state.ix2031List[i] = { ...state.ix2031List[i], ...newItem } }
            }
        })
        builder.addCase(saveIx2031.rejected, (state, action) => {
            state.saveIx2031Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveIx2031Error = action.error.message
            } else {
                state.saveIx2031Error = action.payload
            }
        })

        builder.addCase(deleteIx2031.pending, (state) => {
            state.deleteIx2031Status = 'pending'
            state.deleteIx2031Error = undefined
        })
        builder.addCase(deleteIx2031.fulfilled, (state, action) => {
            state.deleteIx2031Status = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ix2031List = state.ix2031List.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ix2031List = state.ix2031List.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteIx2031.rejected, (state, action) => {
            state.deleteIx2031Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteIx2031Error = action.error.message
            } else {
                state.deleteIx2031Error = action.payload
            }
        })

    }
})

export const {
    resetloadIx2031ListError,
    resetloadIx2031,
    resetloadIx2031Error,
    resetsaveIx2031,
    resetsaveIx2031Error,
    resetdeleteIx2031Error,
    removeFromIx2031ListById,
    removeFromIx2031ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Ix2031Slice.actions
export default Ix2031Slice.reducer
